export default "__VITE_ASSET__aGJfCYBH__"